import {fromEvent} from 'rxjs';
import {filterDigits, format} from '../libs/phone-mask-formatter';

/**
 *
 * @param {HTMLInputElement} input
 * @returns {(): void}
 */
const applyMaskTo = (input) => () => {
    const value = filterDigits(input.value);
    const formattedValue = format(value);

    if (formattedValue)
        input.value = `+${formattedValue}`;
    else
        input.value = '';
}

/**
 *
 * @param {HTMLInputElement} input
 * @returns {(): void}
 */
export const setCarretAtTheEnd = (input) => () => {
    const carret = input.value.length;

    input.setSelectionRange(carret, carret);
}

export default function applyPhoneMask(input) {
    if (!input) return;

    const inputEvents$ = fromEvent(input, 'input');
    const focusEvents$ = fromEvent(input, 'focus');

    focusEvents$.subscribe(setCarretAtTheEnd(input));
    inputEvents$.subscribe(applyMaskTo(input));

    if (!input.value)
        input.value = '+7';

    input.dispatchEvent(new Event('input'));
}
